/** Bump when you need a no-op JS change to unblock a stuck CDN deploy; see README. */
const CLOUDFLARE_OOPSIE_COUNT = 8;

declare global {
  interface Window {
    cloudflareOopsieCount: number;
  }
}

window.cloudflareOopsieCount = CLOUDFLARE_OOPSIE_COUNT;

export {};
